// LICENSE_CODE ZON
'use strict'; /*jslint node:true, es6:true, react:true*/
import React, {useContext} from 'react';
import zurl from 'zurl';
// @ts-ignore
import {App_context} from '../context.js';

interface i_google_map_props {
    t?: string;
    z?: number;
    f?: string;
    q?: string;
    hl?: string;
    ll?: string;
    sll?: string;
    sspn?: string;
    near?: string;
    geocode?: string;
    cls?: string;
}

export const Google_map = (props: i_google_map_props)=>{
    const {cls} = props;
    const {is_client} = useContext(App_context);
    const qs = zurl.qs_str({
        f: props.f || 'q',
        q: props.q || '',
        z: props.z || 14,
        t: props.t || 'm',
        hl: props.hl || 'en',
        ll: props.ll || '',
        sll: props.sll || '',
        sspn: props.sspn || '',
        near: props.near || '',
        geocode: props.geocode || '',
        ie: 'UTF8',
        iwloc: 'near',
        output: 'embed',
    });
    const src = `https://maps.google.com/maps?${qs}`;
    if (!is_client)
        return null;
    return <iframe className={cls} frameBorder="0" scrolling="no"
      marginHeight={0} marginWidth={0} width="100%" height="100%"
      src={src}>
    </iframe>;
};
